/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bulkImport.vue?vue&type=template&id=46062744&scoped=true"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"
import style0 from "./bulkImport.vue?vue&type=style&index=0&id=46062744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46062744",
  null
  
)

export default component.exports